import { User } from 'firebase/auth';

import { getCurrentUser } from './auth';

/**
 * returns the id used for indexing a user's submissions
 *
 * @todo retrieve current pre-employment assessment and use that as the id
 *       the current implementation has the forms + the pre-employment assessment indexing by the user id so it works for now
 *       if in the future we want to support taking the test multiple times, this will have to change
 */
export async function getIdForFormRecord(): Promise<string> {
  const user: User | null = getCurrentUser();
  if (!user) {
    // TODO: use custom errors
    throw new Error('User not authenticated!');
  }

  return user.uid;
}
